// extracted by mini-css-extract-plugin
export default {"lang":"Languages_lang__oxkHw","active":"Languages_active__QZsjT"};